import { Page } from 'components';
import { useContext } from 'react';
import { Filters, Results } from './components';
import { productInfoContext } from './ProductCheckContext';


let ProductCheck = () => {
    let { isSearching } = useContext(productInfoContext);

    return (
        <Page
            useHeader={true}
            title="Product informations"
            addNewUrl={"/registration/addnew"}
            isLoading={isSearching}
        >
            <Filters />
            <Results />
        </Page>
    )
}

export default ProductCheck;